import { notification } from "antd";

export function showError(header: string, description: string) {
    notification.error({
        message: header,
        description: description,
        duration: 0
    });
}

export function showSuccess(header: string, description: string) {
    notification.success({
        message: header,
        description: description,
        duration: 7
    });
}